import type { SlotProps } from "input-otp";
import { OTPInput, REGEXP_ONLY_DIGITS } from "input-otp";
import { useEffect } from "react";
import Animated, {
  useAnimatedStyle,
  useSharedValue,
  withRepeat,
  withSequence,
  withTiming,
} from "react-native-reanimated";
import { View, XStack, getTokenValue, useTheme } from "tamagui";

import { Text } from "./Typography";

// TODO: When Nori comes to native, split this into a native version using input-otp-native which has the same API
export interface FixedNumericInputProps {
  value: string;
  onChangeValue: (value: string) => void;
  onSubmit: (value: string) => void;
  borderColor: string;
}

const FakeCursor = () => {
  const theme = useTheme();
  const opacity = useSharedValue(1);

  useEffect(() => {
    opacity.value = withRepeat(
      withSequence(
        withTiming(0, { duration: 500 }),
        withTiming(1, { duration: 500 }),
      ),
      -1,
      true,
    );
  }, [opacity]);

  const animatedStyle = useAnimatedStyle(
    () => ({
      opacity: opacity.value,
    }),
    [opacity],
  );

  return (
    <View
      position="absolute"
      width="100%"
      height="100%"
      alignItems="center"
      justifyContent="center"
    >
      <Animated.View
        style={[
          {
            width: 2,
            height: getTokenValue("$300"),
            backgroundColor: theme.a11yBlue.get(),
            borderRadius: 1,
          },
          animatedStyle,
        ]}
      />
    </View>
  );
};

const Slot = ({
  char,
  hasFakeCaret,
  borderColor,
}: SlotProps & { borderColor: string }) => {
  return (
    <View
      width="$600"
      height="$500"
      alignItems="center"
      justifyContent="center"
      borderWidth="$strokeWidth"
      borderColor={borderColor}
      borderRadius="$100"
      backgroundColor="$fillInput"
    >
      {char !== null && (
        <Text size="$lg" bold>
          {char}
        </Text>
      )}
      {hasFakeCaret && <FakeCursor />}
    </View>
  );
};

export default function FixedNumericInput({
  onSubmit,
  onChangeValue,
  value,
  borderColor,
}: FixedNumericInputProps) {
  return (
    <OTPInput
      onComplete={onSubmit}
      maxLength={6}
      value={value}
      onChange={onChangeValue}
      pattern={REGEXP_ONLY_DIGITS}
      autoComplete="one-time-code"
      render={({ slots }) => (
        <XStack justifyContent="space-between">
          {slots.map((slot, idx) => (
            <Slot borderColor={borderColor} key={idx} {...slot} />
          ))}
        </XStack>
      )}
    />
  );
}
